import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    args: (string | number)[]
  ): string {
    if (!value) return '';
    if (!args?.length) return value;
    const limit = parseInt(String(args[0]), 10);
    const trail = args.length > 1 ? String(args[1]) : '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
